import InterviewPanel from './InterviewPanel';
export default InterviewPanel;